import { render, staticRenderFns } from "./QuestionSection.vue?vue&type=template&id=23300e02&scoped=true"
import script from "./QuestionSection.vue?vue&type=script&lang=js"
export * from "./QuestionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23300e02",
  null
  
)

export default component.exports